<template>
  <article class="row m-0">
    <p>policy Popup</p>
    <router-link
      :to="{ name: 'CookiesPolicy' }"
      class="nav-link"
      custom
      v-slot="{ navigate }"
    >
      <span
        role="link"
        @click="navigate"
        class="btn"
        @keypress.enter="navigate"
      >
        link.
      </span>
    </router-link>

    <button class="btn me-2" @click="accept">Accept all cookies</button>
    <button class="btn" @click="cansel">Agree later</button>
  </article>
</template>

<script>
export default {
  name: "Popups",
  data() {
    return {};
  },

  mounted() {
    this.$nextTick(() => {});
  },

  methods: {
    cansel() {
      this.$store.state.utils.cookies = false;
    },

    accept() {
      const details = {
        os: this.$store.state.utils.use.osused(),
        browser: this.$store.state.utils.use.browserused(),
        deviceused: this.$store.state.utils.use.deviceused(),
        language: this.$store.state.utils.use.getLanguage(),
      };

      localStorage.setItem("details", JSON.stringify(details));
      this.$store.state.utils.cookies = false;
    },
  },
};
</script>
